import { FLOWS as REGISTRY_FLOWS } from '../integration/registry.js';

/**
 * The event-flow catalogue — a pure PROJECTION of the central registry (`../integration/registry.ts`).
 * A flow is a cross-service choreography (≈ a saga): a named, ordered chain of hops, each one
 * integration event from a producing service to a reacting one, all under one correlation id.
 * Consumed by the Hub Monitor's Standard-flows panel + Catalogue page via `GET /api/hub/flows`.
 */
export interface FlowStep {
  readonly event: string;
  readonly from: string;
  readonly to: string;
  readonly note?: string;
}
export interface EventFlow {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly steps: readonly FlowStep[];
}

/** Every standard flow, projected from the registry. */
export const EVENT_FLOWS: readonly EventFlow[] = Object.freeze(
  REGISTRY_FLOWS.map((f): EventFlow => ({
    id: f.id,
    name: f.name,
    description: f.description,
    steps: f.steps.map((s) => (s.note !== undefined ? { event: s.event, from: s.from, to: s.to, note: s.note } : { event: s.event, from: s.from, to: s.to })),
  })),
);

/** ISO date the flow projection was last revised. */
export const EVENT_FLOWS_UPDATED = '2026-07-29';

/** Look up a flow by id (undefined if not catalogued). */
export function flowById(id: string): EventFlow | undefined {
  return EVENT_FLOWS.find((f) => f.id === id);
}
